import script from "./ForwardMessageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForwardMessageModal.vue?vue&type=script&setup=true&lang=ts"

import "./ForwardMessageModal.vue?vue&type=style&index=0&id=17ffb206&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ffb206"]])

export default __exports__